// extracted by mini-css-extract-plugin
module.exports = {"home":"home-module--home--3KMk4","content":"home-module--content--3ePed"};